import { LogisticList } from './LogisticList';
import { construct, map, tap, pipe } from 'ramda';
import { LogisticEntry } from './LogisticList';
import { Can } from '@casl/vue';
import { LogisticModal } from './LogisticModal';

class DeliveryServiceEntry {
	constructor(data) {
		this.id = data.VALUE;
		this.name = data.NAME;
	}
}

class CargoTypeEntry {
	constructor(data) {
		this.id = data.VALUE;
		this.name = data.NAME;
	}
}

const createLogisticEntry = construct(LogisticEntry);
const createDeliveryServiceEntry = construct(DeliveryServiceEntry);
const createCargoTypeEntry = construct(CargoTypeEntry);
const setData = item => vm => vm.item = item ?? null;
const mount = (vm) => {
	vm.$mount();
	document.body.appendChild(vm.$el);
}
const show = vm => vm.$refs.modal.show();

const createForm = (item) => pipe(
	() => new Vue(LogisticModal),
	tap(setData(item)),
	tap(mount),
	tap(show)
)();

export const Logistic = {
	name: 'Logistic',
	props: {
		initialDeliveryServices: Array,
		initialLogistics: Array,
		initialCargoTypes: Array,
	},
	data: (vm) => ({
		logistics: map(createLogisticEntry, vm.initialLogistics),
		deliveryServices: map(createDeliveryServiceEntry, vm.initialDeliveryServices),
		cargoTypes: map(createCargoTypeEntry, vm.initialCargoTypes),
	}),
	methods: {
		addLogistic() {
			const vm = createForm();
			vm.deliveryServices = this.deliveryServices;
			vm.cargoTypes = this.cargoTypes;
		},
		editLogistic(item) {
			const vm = createForm(item);
			vm.deliveryServices = this.deliveryServices;
			vm.cargoTypes = this.cargoTypes;
		},
	},
	render(h) {
		return (
			<div>
				<h3 class="font-weight-bold mb-4">Логистика</h3>
				<LogisticList
					list={ this.logistics }
					onEdit={ this.editLogistic }
				/>
				<Can I="create" a="Logistic">
					<button
						type="button"
						style={{ color: '#009996' }}
						onClick={ this.addLogistic }
					>
						Добавить перемещение
					</button>
				</Can>
			</div>
		)
	}
}
